<style scoped>

  .ui.main.segment {
    min-height: 400px;
  }

  .filter-segment {
    padding-top: 25px !important; 
    padding-bottom: 0px !important; 
    padding-right: 18px !important;
  }

</style>

<template>
  
  <div>

    <div class="ui main segment" :class="{ loading }">

      <div class="ui form">
        <div class="fields">
          <div class="two wide field">
            <label class="form-label">Data Inicial</label>
            {{ $formatDate(filter.startDate) }}
          </div>
          <div class="two wide field">
            <label class="form-label">Data Final</label>
            {{ $formatDate(filter.endDate) }}
          </div>                    
          <div class="twelve wide field">
            <label class="form-label">Cliente</label>
            {{ customer.name }}
            <div class="ui small label m-l-5">
              Período de Pagamento
              <div class="detail">{{ paymentPeriod }}</div>
            </div> 
          </div>          
        </div>
      </div>

      <div class="ui grid m-t-20">
        <div class="eight wide column">
          <button class="ui mini basic button" :class="{ disabled: disableSelectionButtons }" @click="onSelectAll()">
            <i class="check double blue icon"></i> Selecionar todos
          </button>
          <button class="ui mini basic button m-l-10" :class="{ disabled: disableSelectionButtons }" @click="onRemoveSelection()">
            <i class="times red icon"></i> Remover seleção
          </button> 
        </div>
        <div class="eight wide column filter-segment">
          <div class="ui basic right aligned segment no-margin no-padding">
            <div class="ui dropdown filter-dropdown">
              Filtrar <i class="caret down icon"></i>
              <div class="menu">
                <div class="header">Status Financeiro</div>
                <div v-for="status in financialStatusList" class="item" @click="onFilterStatus(status)">
                   <i :class="status.icon"></i> {{ status.description }}
                   <i v-if="status.selected" class="check blue icon m-l-5"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <table v-if="certs.length > 0" class="ui celled selectable tablet stackable table">
        <thead v-if="$isDesktop">
          <tr>
            <th>Número</th>
            <th>Data</th>
            <th>Animal</th>
            <th>Tutor</th>
            <th>Colaborador</th>
            <th>Valor Recebido</th>
            <th v-if="hasAnticipation">Valor Antecipado</th>
            <th>Valor a Receber</th>   
            <th></th>
          </tr>  
        </thead>
        <tbody>
          <tr v-for="(cert, index) in certs" :class="{ negative: cert.financialStatus != 'finished' }" 
            @click="onSelectCert(index)">
            <td>
              <strong class="mobile-only">Número: </strong> 
              <i v-if="canSelect(cert)" class="circle blue icon m-r-15" :class="{ check: cert.selected, outline: !cert.selected }"></i>
              <i v-else class="ban grey icon m-r-15"></i>              
              <i :class="cert.financialStatusData.icon"></i>
              {{ cert.id }}
            </td>
            <td>
              <strong class="mobile-only">Data: </strong> {{ $formatDate(cert.date) }}
            </td>            
            <td>
              <strong class="mobile-only">Animal: </strong>
              <i v-if="cert.animalSex == 'male'" class="mars blue icon"></i>
              <i v-if="cert.animalSex == 'female'" class="venus pink icon"></i>
              {{ cert.animalName.trim() }}
              <div v-if="cert.registrationId" class="ui small label">
                {{ cert.registrationId }}
              </div>
            </td>
            <td>
              <strong class="mobile-only">Tutor: </strong> 
              {{ cert.ownerName }}                
            </td>            
            <td>
              <strong class="mobile-only">Colaborador: </strong>
              {{ cert.userName }}
            </td>            
            <td>
              <strong class="mobile-only">Valor Recebido: </strong> R$ {{ $formatCurrency(cert.receivedValue) }}
            </td>
            <td v-if="hasAnticipation">
              <strong class="mobile-only">Valor Antecipado: </strong> R$ {{ $formatCurrency(cert.anticipationValue) }}
            </td>
            <td>
              <strong class="mobile-only">Valor a Receber: </strong> R$ {{ $formatCurrency(cert.invoiceableValue) }}
            </td>            
            <td class="details-cell">
              <button class="ui small icon button" @click="showCert($event, cert.id)">
                <i class="search plus icon"></i>
              </button>
            </td>
          </tr>                
        </tbody>
      </table>

      <p v-if="!loading && certs.length == 0" class="grey text m-t-30">
        <i class="info circle icon"></i> Nenhum laudo encontrado
      </p>

      <div v-if="!loading && resume.length > 0" class="m-t-25">
        <table class="ui celled selectable tablet stackable table">
          <thead v-if="$isDesktop">
            <tr>
              <th>Serviço</th>
              <th>Laudos</th>
              <th>Valor Total</th>
              <th>Total Recebido</th>
              <th v-if="hasAnticipation">Total Antecipado</th>
              <th>Total a Receber</th>
            </tr>  
          </thead>
          <tbody>
            <tr v-for="(service, index) in resume">                            
              <td>
                <strong class="mobile-only">Serviço: </strong> 
                {{ service.description }}
                <span class="ui small label m-l-10">
                  <i :class="service.typeIcon"></i>
                  {{ service.typeDescription }}
                </span>
              </td>              
              <td>
                <strong class="mobile-only">Laudos: </strong> {{ $formatInteger(service.count) }}   
              </td>
              <td>
                <strong class="mobile-only">Valor Total: </strong> R$ {{ $formatCurrency(service.value) }}
              </td>
              <td>
                <strong class="mobile-only">Total Recebido: </strong> R$ {{ $formatCurrency(service.receivedValue) }}
              </td>
              <td v-if="hasAnticipation">
                <strong class="mobile-only">Total Antecipado: </strong> R$ {{ $formatCurrency(service.anticipationValue) }}
              </td>
              <td>
                <strong class="mobile-only">Total a Receber: </strong> R$ {{ $formatCurrency(service.invoiceableValue) }}
              </td>              
            </tr>                
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td class="bold text">{{ $formatInteger(totals.count) }}</td>
              <td class="bold text">R$ {{ $formatCurrency(totals.value) }}</td>
              <td class="bold text">R$ {{ $formatCurrency(totals.receivedValue) }}</td>
              <td v-if="hasAnticipation" class="bold text">R$ {{ $formatCurrency(totals.anticipationValue) }}</td>
              <td class="bold text">R$ {{ $formatCurrency(totals.invoiceableValue) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>      

    </div>  

    <div v-if="hasPendingCerts" class="ui basic right aligned segment">
      <i class="exclamation circle red icon"></i> Um ou mais laudos do período selecionado ainda não possuem dados financeiros
    </div>  

    <button class="ui basic button" @click="$emit('onBack')">
      <i class="arrow left icon"></i> Voltar
    </button>    

    <button class="ui right floated blue button" :class="{ disabled: (hasPendingCerts || selectedCerts.length == 0) }" 
      @click="$emit('onForward', { selectedCerts, resume, totals })">
      Avançar <i class="arrow right icon"></i> 
    </button>

  </div>

</template>

<script>

  import _ from "underscore"
  import AppBrowser from "@/utils/browser"
  import FinancialService from "@/services/financial-service"
  import CustomerInvoiceService from "@/services/customer-invoice-service"
  import CertService from "@/services/cert-service"
  import SrvService from "@/services/srv-service"

  const service = new CustomerInvoiceService()

  export default {
    
    name: "CertsStep",

    data() {
      return {
        loading: true,
        originCerts: [],
        certs: [],
        financialStatusList: [],
        resume: [],
        totals: {},
      }
    },

    props: ["filter", "customer"],

    mounted() {
      this.loadFinancialStatusDropdown()             
      this.loadCerts()
    },

    computed: {

      disableSelectionButtons() {
        return (this.certs.length == 0)
      },

      paymentPeriod() {

        const label = this.customer.paymentPeriod == "*" ? "Todos" : FinancialService.PAYMENT_PERIOD[this.customer.paymentPeriod].label

        return label
      },

      selectedCerts() {

        let certs = []

        for (const cert of this.certs) {
          if (cert.selected)
            certs.push(cert)
        }

        return certs
      },

      hasAnticipation() {

        for (const cert of this.certs) {
          if (cert.anticipationValue)
            return true
        }

        return false
      },

      hasPendingCerts() {

        for (const cert of this.certs) {
          if (cert.financialStatus != "finished")
            return true
        }

        return false
      },
    },

    methods: {

      loadFinancialStatusDropdown() {

        let list = [{ id: "*", icon: "asterisk icon", description: "Todos", selected: true }]
        const statusList = CertService.getFinancialStatusList()
        
        statusList.forEach((status) => list.push(status))

        this.financialStatusList = list

        $(".filter-dropdown").dropdown()
      },

      async loadCerts() {

        this.loading = true

        try {  

          this.certs = await service.getUninvoicedCerts({
            startDate: this.filter.startDate,
            endDate: this.filter.endDate,
            customerId: this.customer.id,
          })

          this.certs.forEach((cert) => {
            cert.statusData = CertService.STATUS[cert.status]
            cert.financialStatusData = CertService.FINANCIAL_STATUS[cert.financialStatus]
            cert.serviceTypeData = SrvService.TYPE_ICONS[cert.serviceTypeIcon]
          })

          if (this.certs.length == 1)
            this.certs[0].selected = true

          this.originCerts = this.certs.slice()  
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      onSelectCert(index) {

        if (!this.canSelect(this.certs[index]))
          return

        let certs = this.certs.slice()

        certs[index].selected = !certs[index].selected

        this.certs = certs

        this.updateResume()
      },

      canSelect(cert) {
        return (cert.financialStatus == "finished")
      },

      onSelectAll() {

        this.certs = this.certs.map((cert) => {
          if (this.canSelect(cert))  
            cert.selected = true
          return cert
        })

        this.updateResume()
      },

      onRemoveSelection() {
        
        this.certs = this.certs.map((cert) => {
          cert.selected = false
          return cert
        })

        this.updateResume()
      },

      updateResume() {

        let resume = []
        let service = null        

        this.resume = []
        this.totals = { count: 0, value: 0, receivedValue: 0, anticipationValue: 0, invoiceableValue: 0 }

        for (const cert of this.certs) {

          if (!cert.selected)
            continue

          service = resume.find((srv) => srv.id == cert.serviceId && srv.typeId == cert.serviceTypeId)

          if (service) {
            
            service.count++
            service.value += cert.value            
            service.receivedValue += cert.receivedValue
            service.anticipationValue += cert.anticipationValue
            service.invoiceableValue += cert.invoiceableValue

          } else {

            resume.push({
              count: 1,
              value: cert.value,              
              receivedValue: cert.receivedValue,
              anticipationValue: cert.anticipationValue,
              invoiceableValue: cert.invoiceableValue,
              id: cert.serviceId,
              typeId: cert.serviceTypeId,
              description: cert.serviceDescription,
              typeDescription: cert.serviceTypeDescription,
              typeIcon: cert.serviceTypeData.icon,
              sortKey: cert.serviceDescription.trim().toLowerCase() + cert.serviceTypeDescription.trim().toLowerCase(),
            })
          }

          this.resume = _.sortBy(resume, "sortKey")

          this.totals.count++
          this.totals.value += cert.value          
          this.totals.receivedValue += cert.receivedValue
          this.totals.anticipationValue += cert.anticipationValue
          this.totals.invoiceableValue += cert.invoiceableValue
        }
      },

      onFilterStatus(status) {

        let statusList = this.financialStatusList.slice()

        statusList.forEach((el) => {
          el.selected = (el.id == status.id)
        })

        this.financialStatusList = statusList.slice()

        if (status.id == "*") {
          this.certs = this.originCerts.slice()
        } else {
          this.certs = this.originCerts.filter((cert) => cert.financialStatus == status.id)
        }        
      },

      showCert($event, id) {
        
        $event.stopPropagation()

        AppBrowser.openNewTab(`/procs/certs/${id}/show`)
      },
    },
  }

</script>